/** Angular imports */
import { Component, inject } from '@angular/core';

/** Core imports */
import { AddContentStepsService } from '@core';

/** Component imports */
import { PlaylistSettingsContentComponent } from '@features/playlists/components/ui/playlist-settings-content/playlist-settings-content.component';
import { PlaylistSettingsData } from '@features/playlists/interfaces';

/** Local imports */
import {
    ADD_CONTENT_SETTINGS_SUB_TAB,
    ADD_CONTENT_SETTINGS_TAB,
} from '@features/playlists/constants';

@Component({
    selector: 'app-settings',
    imports: [PlaylistSettingsContentComponent],
    templateUrl: './settings.component.html',
    styleUrl: './settings.component.scss',
})
export class SettingsComponent {
    /** Injected add content service to validate step and access steps draft data */
    private addContentStepsService = inject(AddContentStepsService);

    /** Add content settings main tabs */
    protected readonly tabs = ADD_CONTENT_SETTINGS_TAB;

    /** Add content settings content schedule tab tabs */
    protected readonly subTabs = ADD_CONTENT_SETTINGS_SUB_TAB;

    public saveDataToDraft(): void {
        // Now handled by onSettingsChange
    }

    protected onSettingsChange(data: PlaylistSettingsData): void {
        this.addContentStepsService.updateDraft('settings', data);

        // Basic validation: duration must be valid
        const isValid = data.duration >= 5;
        this.addContentStepsService.setStepValidity(2, isValid);
    }
}
